import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { MdOutlinePerson, MdOutlineBookmarks } from 'react-icons/md';
import './ProfileSidebar.css';

const TABS = [
  { key: 'profile',       label: 'Profile',       Icon: MdOutlinePerson },
  { key: 'saved-filters', label: 'Saved Filters', Icon: MdOutlineBookmarks }
];

const ProfileSidebar = ({ onClose, isMainSidebarCollapsed }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'profile';

  const handleTabChange = (key) => {
    navigate(`/profile?tab=${key}`, { replace: true });
  };

  return (
    <div className={`profile-sidebar ${isMainSidebarCollapsed ? 'main-sidebar-collapsed' : ''}`}>
      <div className="profile-sidebar-header">
        <div className="profile-sidebar-title">
          <MdOutlinePerson size={18} />
          <span>My Account</span>
        </div>
        <button className="profile-sidebar-close" onClick={onClose} title="Close">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      <nav className="profile-sidebar-nav">
        {TABS.map(({ key, label, Icon }) => (
          <button
            key={key}
            className={`profile-nav-item ${activeTab === key ? 'active' : ''}`}
            onClick={() => handleTabChange(key)}
          >
            <Icon size={18} />
            <span>{label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ProfileSidebar;
